import React from 'react';
import { animated } from 'react-spring';
import * as cn from 'classnames';
import PropTypes from 'prop-types';

function Card({ className, children, ...props }) {
  return (
    <animated.div
      className={cn('card', { [className]: !!className })}
      {...props}
    >
      {children}
    </animated.div>
  );
}

Card.defaultProps = {
  className: '',
};

Card.propTypes = {
  className: PropTypes.string,
};

export default React.memo(Card);
